import { FC } from 'react';
import { flatten, values } from 'lodash-es';

import { WorkflowStepFormFieldSelect } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const CategoryFieldToBlock: FieldToBlock<
  'category',
  WorkflowStepFormFieldSelect
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentProps: {
    [field.usesOptionGroups ? 'groups' : 'options']: field.options,
    size: 'sm',
  },
  componentType: 'select',
});

type CategoryFieldValueProps = FieldValueProps<'category'>;

export const CategoryFieldValue: FC<CategoryFieldValueProps> = ({ field }) => {
  const options = field.usesOptionGroups
    ? flatten(values(field.options))
    : field.options;
  const option = options.find((o) => o.value === field.value);

  return <>{((option && option.label) || field.value) ?? '–'}</>;
};
